// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
export type OrganizationSelectFragment = {
  __typename?: "User";
  organizations: Array<{
    __typename?: "Organization";
    id: string;
    name: string;
    slug: string;
  }>;
};

export const OrganizationSelectFragmentDoc = gql`
  fragment OrganizationSelect on User {
    organizations {
      id
      name
      slug
    }
  }
`;
